import { payNoMarketAddress } from 'src/app/models/pay-no-market-address.model';

export const ENSContracts = {
  registrar: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
  reverseRegistry: '0x084b1c3C81545d370f3634392De611CaaBFf8148',
  reverseRegistryTestnet: '0xD5610A08E370051a01fdfe4bB3ddf5270af1aA48',
  resolver: '0x4976fb03C32e5B8cfe2b6cCB31c09Ba78EBaBa41',
  resolverTestnet: '0x4B1488B7a6B320d2D721406204aBc3eeAa9AD329',
  registrarController: '0x283Af0B28c62C092C9727F1Ee09c02CA627EB7F5',
  migrationContract: '0x6109DD117AA5486605FC85e040ab00163a75c662',
  token: '0x57f1887a8BF19b14fC0dF6Fd9B2acc9Af147eA85',
  nullResolver: payNoMarketAddress,
};
